// extracted by mini-css-extract-plugin
export default {"player":"PlayerComponent_player__vnQIy","lost":"PlayerComponent_lost__Cf4Av"};